import React, { useMemo } from "react";
import { View, StyleSheet } from "react-native";
import NtText from "../../components/NtText";
import NtButton from "../../components/NtButton";
import { useTheme } from "../../context/ThemeContext";
import routes from "../../navigation/routes";
import { navigationRef } from "../../../App";

function NtOnboardingCtaBlock({ containerStyle }) {
  const { theme } = useTheme();
  const styles = useMemo(() => makeStyles(theme), [theme]);

  const handleStart = () => {
    if (navigationRef.current) {
      navigationRef.current.navigate(routes.onboarding);
    }
  };

  return (
    <View style={[styles.block, containerStyle]}>
      <View style={styles.eyebrow}>
        <View style={styles.dot} />
        <NtText style={styles.eyebrowText}>New account</NtText>
      </View>

      <NtText style={styles.headline}>Don't have an account yet?</NtText>
      <NtText style={styles.sub}>
        Walk through company setup and pick a plan — we'll get your account
        ready in a few minutes.
      </NtText>

      <NtButton
        text="Create account →"
        onPress={handleStart}
        containerStyle={styles.btn}
      />
    </View>
  );
}

const makeStyles = (t) =>
  StyleSheet.create({
    block: {
      marginTop: 32,
      paddingTop: 24,
      borderTopWidth: 1,
      borderTopColor: t.borderSoft,
      maxWidth: 460,
    },
    eyebrow: { flexDirection: "row", alignItems: "center", gap: 8, marginBottom: 8 },
    dot: { width: 6, height: 6, borderRadius: 3, backgroundColor: t.brand2 },
    eyebrowText: {
      fontSize: 11,
      fontWeight: "700",
      color: t.brand2,
      letterSpacing: 1.2,
      textTransform: "uppercase",
    },
    headline: {
      fontSize: 16,
      fontWeight: "700",
      color: t.text,
      letterSpacing: -0.2,
      marginBottom: 6,
    },
    sub: {
      fontSize: 12.5,
      color: t.textDim,
      lineHeight: 18,
      maxWidth: 420,
      marginBottom: 14,
    },
    btn: { alignSelf: "flex-start", paddingHorizontal: 18, paddingVertical: 11 },
  });

export default NtOnboardingCtaBlock;
